import PropTypes from 'prop-types'
import { Popover } from 'reactstrap'
import {
  DndContext,
  closestCenter,
  PointerSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  SortableContext,
  verticalListSortingStrategy,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'

import SortableColumnItem from './SortableColumnItem'

import classes from './ColumnManagementPopover.module.scss'

const ColumnManagementPopover = ({
  isOpen,
  toggle,
  allColumns,
  hiddenColumns,
  toggleColumn,
  reorderColumns,
  resetToDefaults,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  const handleDragEnd = (event) => {
    const { active, over } = event
    if (over && active.id !== over.id) {
      reorderColumns(active.id, over.id)
    }
  }

  return (
    <Popover
      placement='bottom-end'
      isOpen={isOpen}
      target='columnManagementButton'
      toggle={toggle}
      trigger='legacy'
      className={classes.popoverContainer}
    >
      <div className={classes.popover}>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={allColumns.map(c => c.field)}
            strategy={verticalListSortingStrategy}
          >
            <div className={classes.columnList}>
              {allColumns.map(col => (
                <SortableColumnItem
                  key={col.field}
                  column={col}
                  isVisible={!hiddenColumns.includes(col.field)}
                  onToggle={toggleColumn}
                />
              ))}
            </div>
          </SortableContext>
        </DndContext>
        <button className={classes.resetButton} onClick={resetToDefaults}>
          Reset to Defaults
        </button>
      </div>
    </Popover>
  )
}

ColumnManagementPopover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  allColumns: PropTypes.array.isRequired,
  hiddenColumns: PropTypes.array.isRequired,
  toggleColumn: PropTypes.func.isRequired,
  reorderColumns: PropTypes.func.isRequired,
  resetToDefaults: PropTypes.func.isRequired,
}

export default ColumnManagementPopover
